interface PdfViewerProps {
  arquivo: string;
  width?: string;
  height?: string;
}

function PdfViewer({ arquivo, width = "98%", height = "800px" }: PdfViewerProps) {
  return (
    <iframe
      title="Visualizador de PDF"
      src={arquivo}
      width={width}
      height={height}
      style={{ border: "none" }}
    />
  );
}

export default PdfViewer;
